import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-camera",
  "use": "icon-camera-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-camera\"><defs><style type=\"text/css\"></style></defs><path d=\"M304 608a208 208 0 1 0 416 0 208 208 0 0 0-416 0zM960 256h-224c-16-64-32-128-96-128h-256c-64 0-80 64-96 128H64c-35.2 0-64 28.8-64 64v576c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64V320c0-35.2-28.8-64-64-64zM512 892c-156.864 0-284-127.136-284-284s127.136-284 284-284 284 127.136 284 284-127.136 284-284 284zM960 448h-128v-64h128v64z\" p-id=\"2757\" fill=\"#bfbfbf\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/camera.svg
// module id = 2vhn
// module chunks = 40